import React, { useState } from 'react';

export default function GitHubAuth() {
  const [hovered, setHovered] = useState(false);
  
  const handleLogin = () => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
    window.location.href = `${apiUrl}/auth/github`;
  };
  
  return (
    <div style={styles.container}>
      <div style={{
        ...styles.card,
        animation: 'fadeIn 0.6s ease-out'
      }}>
        <div style={styles.iconContainer}>
          <svg style={styles.githubLogo} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" fill="#10a37f"/>
          </svg>
        </div>
        <h1 style={{
          ...styles.title,
          animation: 'fadeIn 1s ease-out'
        }}>GitGreen</h1>
        <p style={{
          ...styles.description,
          animation: 'fadeIn 1.2s ease-out'
        }}>
          Connect your GitHub account to automatically generate commits to your repositories
        </p>
        <button 
          onClick={handleLogin} 
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            ...styles.button,
            ...(hovered ? styles.buttonHover : {})
          }}
        >
          <svg style={styles.githubIcon} viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
          Connect with GitHub
        </button>
        <p style={styles.disclaimer}>
          By using this service, you agree to use it responsibly and in compliance with GitHub's Terms of Service.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#212121',
    padding: '20px',
    position: 'relative',
    overflow: 'hidden',
  },
  card: {
    background: '#343541',
    borderRadius: '16px',
    padding: '56px 48px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    textAlign: 'center',
    maxWidth: '480px',
    width: '100%',
    border: '1px solid #565869',
    backdropFilter: 'blur(10px)',
  },
  iconContainer: {
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'center',
    animation: 'fadeIn 0.8s ease-out',
  },
  githubLogo: {
    width: '80px',
    height: '80px',
    filter: 'drop-shadow(0 4px 12px rgba(16, 163, 127, 0.4))',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  title: {
    fontSize: '32px',
    fontWeight: '600',
    color: '#ececf1',
    margin: '0 0 16px 0',
    letterSpacing: '-0.5px',
  },
  description: {
    fontSize: '15px',
    color: '#8e8ea0',
    margin: '0 0 40px 0',
    lineHeight: '1.6',
  },
  button: {
    background: '#10a37f',
    color: '#ffffff',
    border: 'none',
    borderRadius: '10px',
    padding: '16px 32px',
    fontSize: '15px',
    fontWeight: '500',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 12px rgba(16, 163, 127, 0.3)',
    position: 'relative',
    overflow: 'hidden',
  },
  buttonHover: {
    background: '#0d8f6e',
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(16, 163, 127, 0.4)',
  },
  githubIcon: {
    width: '20px',
    height: '20px',
  },
  disclaimer: {
    fontSize: '11px',
    color: '#8e8ea0',
    marginTop: '24px',
    lineHeight: '1.4',
    opacity: 0.7,
  },
};
